import React, { useEffect, useState } from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { adminMargemGet, adminMargemSave } from '../../lib/api';

const MargemSection = () => {
  const [valor, setValor] = useState('');
  const [desc, setDesc] = useState('0');
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { adminMargemGet().then((r) => { setValor(String(r.margem_percent)); setDesc(String(r.desconto_balcao_percent)); }); }, []);

  const salvar = async (e) => {
    e.preventDefault();
    const n = Number(String(valor).replace(',', '.'));
    const d = Number(String(desc).replace(',', '.'));
    if (Number.isNaN(n) || n < 0 || n > 40) { setMsg({ ok: false, text: 'A margem deve ficar entre 0 e 40.' }); return; }
    if (Number.isNaN(d) || d < 0 || d > 80) { setMsg({ ok: false, text: 'O desconto sobre o balcão deve ficar entre 0 e 80.' }); return; }
    setBusy(true); setMsg(null);
    try {
      await adminMargemSave(n, d);
      setMsg({ ok: true, text: 'Margem salva.' });
    } catch (err) {
      setMsg({ ok: false, text: err?.response?.data?.detail || 'Erro ao salvar.' });
    } finally { setBusy(false); }
  };

  const exemplo = (100 * (1 + (Number(String(valor).replace(',', '.')) || 0) / 100)).toFixed(2).replace('.', ',');

  return (
    <section className="bg-white rounded-2xl border border-slate-100 p-6 max-w-2xl">
      <h2 className="text-lg font-semibold text-slate-900">Margem de lucro</h2>
      <p className="text-sm text-slate-500 mb-5">Percentual somado ao preço do seu contrato, para todos os clientes (máximo 40%).</p>
      <form onSubmit={salvar} className="space-y-4">
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Margem (%)</span>
          <Input className="mt-1 max-w-[160px]" inputMode="decimal" value={valor} onChange={(e) => setValor(e.target.value)} required />
        </label>
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Desconto mínimo sobre o preço de balcão (%)</span>
          <Input className="mt-1 max-w-[160px]" inputMode="decimal" value={desc} onChange={(e) => setDesc(e.target.value)} required />
          <span className="block text-xs text-slate-500 mt-1">O cliente nunca paga mais que o balcão menos este desconto, e nunca menos que o seu custo. Precisa das credenciais dos Correios para consultar o balcão.</span>
        </label>
        <p className="text-xs text-slate-500">Exemplo: frete de R$ 100,00 no contrato é vendido por R$ {exemplo}.</p>
        {msg && <p className={`text-sm ${msg.ok ? 'text-emerald-600' : 'text-red-600'}`}>{msg.text}</p>}
        <Button type="submit" disabled={busy} className="inn-btn-primary rounded-full h-10 px-6">Salvar</Button>
      </form>
    </section>
  );
};

export default MargemSection;
